import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=4cf09609&scoped=true&"
import script from "./CustomCard.vue?vue&type=script&lang=ts&"
export * from "./CustomCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=4cf09609&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf09609",
  null
  
)

export default component.exports